
/*
Defines the custom element <ravel-cgol-grid>
*/

import { RavelCgolGrid } from './src/RavelCgolGrid.js';

customElements.define('ravel-cgol-grid', RavelCgolGrid);
